import React, { Component } from 'react';
import { ItemHeader } from './ItemHeader'
import logo from '../Images/LogoRedinet.webp';
import logoRDCR from '../Images/Redinet_CR.webp';
import logoRDMX from '../Images/Redinet_MX.webp';
import logoRDPE from '../Images/Redinet_PE.webp';
import logoSolo from '../Images/Redinet_Solo.webp';
import logoIWS from '../Images/Logo IWS2.webp';
import { Link } from 'react-router-dom';
import logoPartner from '../Images/Logo/Redinet-Web-Partner.webp';
import logoPartnerMobile from '../Images/Logo/Redinet-Web-Partner-mobile.webp';
import logoAliado from '../Images/Logo/Redinet-Web-Aliado.webp';
import logoAliadoMobile from '../Images/Logo/Redinet-Web-Partner-mobile.webp';



import ResponsiveImage from './ResponsiveImage';
// METODO ORIGINAL
// export function ListHeader() {
//   return (
//     <div className="collapse navbar-collapse" id="navbarSupportedContent">
//       <ul className="navbar-nav me-auto mb-2 mb-lg-0">
//         <ItemHeader />
//       </ul>
//     </div>
//   )
// }
const domainName = window.location.hostname;


export class ListHeader extends Component {

  constructor(props) {
    super(props)

    // Establecer un estado
    this.state = { messageClass: 'justify-content-center collapse navbar-collapse' }

    this.handler = this.handler.bind(this);

    this.cont = 0;
  }

  // Este método se enviará al componente secundario
  handler() {
    this.cont++;
    this.setState({ messageClass: 'justify-content-center collapse navbar-collapse nav' + this.cont })
  }

  render() {
    return (
      <div>
        <div className={this.state.messageClass} id="navbarSupportedContent" hidden>
          <Link className="navbar-brand m-0" to="/">
            {(() => {
              // Si el dominio es redinet.us usamos logoPartner, en cualquier otro caso usamos logoAliado
              const isPartner = domainName.includes('redinet.us');
              const desktopLogo = isPartner ? logoPartner : logoAliado;
              const mobileLogo = isPartner ? logoPartnerMobile : logoAliadoMobile;
              const altText = isPartner ? 'Logo Redinet Partner' : 'Logo Redinet Aliado';
              return (
                <ResponsiveImage
                  desktopSrc={mobileLogo}
                  mobileSrc={mobileLogo}
                  alt={altText}
                  className="d-inline-block align-text-top d-none d-md-block logo-desktop"
                />
              )
            })()}
          </Link>
          <ul className="navbar-nav justify-content-center mb-lg-0">
            <ItemHeader action={this.handler} />
          </ul>
        </div>

      </div>
    );
  }
}




